import { Input } from '../ui/input';
import { Textarea } from '../ui/textarea';
import { Button } from '../ui/button';
import { Checkbox } from '../ui/checkbox';
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '../ui/select';
import { DocUploader, DocList } from './DocUploader';

const YesNo = ({ value, onChange, disabled, testId }) => (
  <div className="flex gap-2">
    {['yes', 'no'].map((v) => (
      <Button key={v} type="button" size="sm" variant={value === v ? 'default' : 'outline'} disabled={disabled} onClick={() => onChange(v)} data-testid={`${testId}-${v}`}>
        {v === 'yes' ? 'Yes' : 'No'}
      </Button>
    ))}
  </div>
);

const Field = ({ q, value, onChange, disabled, ws }) => {
  const t = `itq-${q.key}`;
  if (q.type === 'yesno') return <YesNo value={value} onChange={onChange} disabled={disabled} testId={t} />;
  if (q.type === 'confirm') return <label className="flex items-center gap-2 text-sm"><Checkbox checked={value === 'yes'} disabled={disabled} onCheckedChange={(v) => onChange(v ? 'yes' : null)} data-testid={t} />I confirm</label>;
  if (q.type === 'info_tfn') return <p className="text-sm" data-testid={t}>{ws.tfn_masked || 'Not on file'} <a className="text-primary underline" href="/my-details">My Details</a></p>;
  if (q.type === 'info_bank') return <p className="text-sm" data-testid={t}>{ws.bank_on_file ? 'Bank account on file' : 'No bank account on file'} · <a className="text-primary underline" href="/my-details">change in My Details</a></p>;
  if (q.type === 'select') return (
    <Select value={value || undefined} disabled={disabled} onValueChange={onChange}>
      <SelectTrigger className="h-9 max-w-sm" data-testid={t}><SelectValue placeholder="Choose…" /></SelectTrigger>
      <SelectContent>{q.options.map((o) => <SelectItem key={o} value={o}>{o}</SelectItem>)}</SelectContent>
    </Select>
  );
  if (q.type === 'textarea') return <Textarea value={value || ''} disabled={disabled} onChange={(e) => onChange(e.target.value)} data-testid={t} />;
  return <Input type={q.type === 'number' ? 'number' : 'text'} value={value || ''} disabled={disabled} onChange={(e) => onChange(e.target.value)} className="max-w-sm" data-testid={t} />;
};

export const ItrQuestion = ({ q, ws, answers, setAnswer, confirm, upload, reload, canUpload }) => {
  const docs = (cat) => ws.documents.filter((d) => d.itr_category === cat);
  const showDocs = q.docs.length > 0 && (answers[q.key] === 'yes' || (q.type === 'select' && answers[q.key]));
  return (
    <div className="space-y-2 border-b border-border/60 py-3 last:border-0" data-testid={`itq-row-${q.key}`}>
      <p className="text-sm font-medium">{q.label}{q.required && <span className="text-destructive"> *</span>}</p>
      {q.help && <p className="text-xs text-muted-foreground">{q.help}</p>}
      <Field q={q} value={answers[q.key]} onChange={(v) => setAnswer(q.key, v)} disabled={ws.locked} ws={ws} />
      {ws.confirm_keys.includes(q.key) && !ws.locked && (
        <Button size="sm" variant="secondary" onClick={() => confirm(q.key)} data-testid={`itq-confirm-${q.key}`}>Still correct – confirm last year's answer</Button>
      )}
      {showDocs && q.docs.map((d) => (
        <div key={d.key} className="rounded bg-muted/40 p-2">
          <p className="text-xs font-medium">{d.label}</p>
          <DocList docs={docs(d.key)} />
          <DocUploader disabled={!canUpload} testId={`itq-upload-${d.key}`} upload={(f, desc) => upload(f, { category: d.key, question_key: q.key, description: desc })} onDone={reload} />
        </div>
      ))}
    </div>
  );
};
